import { useSuspenseQuery } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { GetEmpreendimentosDisponiveisService } from '@/http/get-empreendimentos-disponiveis.service'
import type { TGetEmpreendimentosDisponiveisResponse } from '@/http/get-empreendimentos-disponiveis.service'
import { empreendimentosKeys } from '@/utils/empreendimento-query-keys'

export const useEmpreendimentosDisponiveisSuspense = () => {
  return useSuspenseQuery<TGetEmpreendimentosDisponiveisResponse, AxiosError>({
    queryKey: empreendimentosKeys.disponiveis(),
    queryFn: () => new GetEmpreendimentosDisponiveisService().execute().then((response) => response.data),
  })
}
